import { get } from 'lodash'

import { CONFIGURATION_KEYS, AGE } from 'constants/enums'

export default function handleGetParticipantAge(configuration) {
  const configParticipantAge = get(
    configuration,
    `values[${CONFIGURATION_KEYS.participantAge.id}].intValue`
  )

  return configParticipantAge ? configParticipantAge / 12 : AGE.adult
}
